import React from 'react';
import { Icon } from '@iconify/react';
import Skills from './skills';
import useIsMobile from 'hooks/isMobile';
import TextAnimation from './about/TextAnimation';

const AboutMe = () => {
  
  const isMobileView = useIsMobile();
  const animatedTexts = [
    'Data Scientist',
    'Web Developer',
    'ML Enthusiast',
    'AI/ML Integrator',
  ];

    return (
      <>
      <div id="about" className="min-h-screen flex items-center p-4 md:p-8 relative dark:bg-neutral-800">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-x-16">

          {/* Left Side  */}
          {/* Text Content */}
          <div className="md:w-1/2 text-center md:text-left mb-12 md:mb-0">
            <p className="text-blue-500 text-display font-semibold italic text-lg">It's me</p>
            <h2 className="text-4xl md:text-6xl font-bold my-3 text-neutral-600 dark:text-neutral-200">Shobha Garg</h2>
            <p className="text-xl text-bold text-fuchsia-600 dark:text-fuchsia-400 mb-4 text-shadow-lg">
              <TextAnimation texts={animatedTexts} duration={3000} />
            </p>
            <p className="text-lg text-justify text-gray-600 dark:text-neutral-300">
              A lifelong learner who translates my love for mathematics and exploration into a pursuit of Data Science and ML. I move from coding a robust backend to landing a <b>Taekwondo</b> kick, proving I’m always ready to <b>'git'</b> to work
            </p>

            {/* Button */}
            <div className= " mt-8 flex flex-col items-center md:items-start">
              <div className="group relative flex flex-col items-center">
              <a href="#social" className="bg-white text-black border-2 border-red-500 font-bold py-3 px-8 rounded-full hover:bg-red-500 hover:text-white transition duration-300 shadow-lg">
                Connect with me
              </a>
              <div className="flex space-x-4 mt-4 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-screen transition-all duration-300 ease-in-out">
              <a href= "'https://linkedin.com/in/shobhagarg'" target="_blank" rel="noopener noreferrer">
                <Icon icon="mdi:linkedin" className="text-3xl text-blue-500 hover:scale-110 transition-transform" />
              </a>
              <a href= "https://github.com/shobha-garg" target="_blank" rel="noopener noreferrer">
                <Icon icon="mdi:github" className="text-3xl text-black dark:text-white hover:scale-110 transition-transform" />
              </a>
              <a href= "mailto:gargshobha5@gmail.com" target="_blank" rel="noopener noreferrer">
                <Icon icon="mdi:email-outline" className="text-3xl text-red-500 hover:scale-110 transition-transform" />
              </a>
              </div>
            </div>
            </div>
            
          </div>

          {/* Right Side */}
          <div className="md:w-1/2 flex justify-end relative md:ml-16">
            {/* Yellow background starting from mid */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent from-50% to-yellow-400 to 60%"></div>

            <div className="relative z-10">
              {/* Shadow upwards right */}
              <div className="absolute -bottom-4 right-8 w-32 h-12 bg-black/20 rounded-full blur-md transform -rotate-12"></div>

              <img
                src="/images/shobha.png" 
                alt="A portrait of Shobha Garg"
                className="max-h-[500px] object-cover"
              />
            </div>
          </div>

        </div>
      </div>
      <div className="bg-gray-100 dark:bg-neutral-900 py-4">
        <h2 className="text-2xl sm:text-3xl font-bold
            bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 
            bg-clip-text text-center text-transparent p-2">
            I have experience working with
          </h2>
        <Skills />
        <p className="text-neutral-600 dark:text-neutral-400 text-center text-base max-w-2xl mx-auto mt-4">
            {isMobileView ? 'Tap' : 'Hover'} over a skill to see its name
        </p>
      </div>
      </>
    );
};

export default AboutMe;